export const SECTION_ID = 'jira.filter';
